import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, AppContextType } from '@contexts/AppContext';

import Layout, { LayoutProps } from './layout';

export interface TechIPOTrackerProps<TData, TValue>
  extends AppContextType,
    LayoutProps<TData, TValue> {}

const queryClient = new QueryClient();

const TechIPOTracker = <TData, TValue>({
  env,
  initialCurrentUser,
  isWebview,
  ...restProps
}: TechIPOTrackerProps<TData, TValue>): JSX.Element => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <Layout {...restProps} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default TechIPOTracker;
